import { message } from "antd";
import { useEffect, useState } from "react";

import * as thirdpartyService from "V2.0/services/thirdpartyService";
import { showErrorToast } from "V2.0/utils";

function useThirdPartySettings(projectId) {
  const [thirdPartySettings, setThirdPartySettings] = useState(null);

  async function fetchThirdPartySettings() {
    try {
      const response = await thirdpartyService.getthirdpartyData(projectId);
      if (response.status === 200) {
        setThirdPartySettings(response.data);
      }
    } catch (e) {
      showErrorToast(e, "Failed to get third party settings");
    }
  }

  useEffect(() => {
    if (projectId) {
      fetchThirdPartySettings();
    }
  }, [projectId]);

  return {
    thirdPartySettings,
    fetchThirdPartySettings,
  };
}

export { useThirdPartySettings };
